import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { NavLink, RouteComponentProps, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { ApplicationState } from '../../data/applicationStates';
import { headerActionCreators } from '../../data/header/headerActions';
import { HeaderState } from '../../data/header/headerModels';
import { userActionCreators } from '../../data/user/userActions';
import { UserState } from '../../data/user/userModels';
import './footer.css';

/* tslint:disable */

interface FooterState {
    header: HeaderState;
    user: UserState;
}

interface FooterActions {
    headerActions: typeof headerActionCreators;
    userActions: typeof userActionCreators;
}

type FooterProps = FooterState & // ... state we've requested from the Redux store
    FooterActions & // ... plus action creators we've requested
    RouteComponentProps<{}>;

class Footer extends React.Component<FooterProps, {}> {
    constructor(props: FooterProps) {
        super(props);

        this.state = {
            popoverOpen: false
        };
    }

    public render() {
        return (
            <div className="footer">
                {this.props.user.error && this.props.user.error === true ? (
                    <></>
                ) : (
                    <div className="paddingTop">
                        <div className="container-fluid paddingTop">
                            <div className="float-left">
                                {this.props.user.permissions.opportunities.read !== undefined &&
                                this.props.user.permissions.opportunities.read === true ? (
                                    <div>
                                        <NavLink exact={true} to={'/opportunities'} className="navLink">
                                            Opportunities
                                        </NavLink>
                                    </div>
                                ) : null}
                                {this.props.user.permissions.duct.read !== undefined &&
                                this.props.user.permissions.duct.read === true ? (
                                    <div>
                                        <NavLink exact={true} to={'/ductdesign'} className="navLink">
                                            Duct Design
                                        </NavLink>
                                    </div>
                                ) : null}
                                {this.props.user.permissions.orders.read !== undefined &&
                                this.props.user.permissions.orders.read === true ? (
                                    <div>
                                        <NavLink exact={true} to={'/orders'} className="navLink">
                                            Orders
                                        </NavLink>
                                    </div>
                                ) : null}
                                {this.props.user.permissions.orders.read !== undefined &&
                                this.props.user.permissions.orders.read === true ? (
                                    <div>
                                        <NavLink exact={true} to={'/shipments'} className="navLink">
                                            Shipments
                                        </NavLink>
                                    </div>
                                ) : null}
                                {this.props.user.permissions.invoices.read !== undefined &&
                                this.props.user.permissions.invoices.read === true ? (
                                    <div>
                                        <NavLink exact={true} to={'/invoices'} className="navLink">
                                            Invoices
                                        </NavLink>
                                    </div>
                                ) : null}
                                <div>
                                    <NavLink exact={true} to={'/internalnews'} className="navLink">
                                        Nordfab Dealer News
                                    </NavLink>
                                </div>
                                <div>
                                    <a className="navLink" target="_blank" href="https://www.nordfab.com/en-us/latest-news/">
                                        News
                                    </a>
                                </div>
                            </div>
                            <div className="float-right">
                                {'Ask your Account Manager for Help:'}
                                <br />
                                <a
                                    className="mail"
                                    href={'mailto:' + this.props.user.contactEmailAddress}
                                    target="_top"
                                >
                                    Send Mail to: {this.props.user.contactEmailAddress}
                                </a>
                                <br />
                                {'800-532-0830'}
                                <br />
                                <br />
                                {'Visit website:'}
                                <br />
                                <a className="mail" href="https://www.nordfab.com/en-us" target="_blank">
                                    {'www.nordfab.com'}
                                </a>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export function mapStateToProps(state: ApplicationState): FooterState {
    return {
        header: state.header,
        user: state.user
    };
}

function mapDispatchToProps(dispatch: Dispatch<{}>): FooterActions {
    return {
        headerActions: bindActionCreators(headerActionCreators, dispatch),
        userActions: bindActionCreators(userActionCreators, dispatch)
    };
}

export default withRouter(
    connect(
        mapStateToProps, // Selects which state properties are merged into the component's props
        mapDispatchToProps // Selects which action creators are merged into the component's props
    )(Footer)
);



// WEBPACK FOOTER //
// ./src/containers/footer/footer.tsx